import { type AxiosInstance } from 'axios'

export default (axios: AxiosInstance) => ({
  checkout(checkoutId: string | number) {
    return axios.post('/v1/stores/checkout/', { checkout_id: checkoutId })
  },
})
